var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M22 13.7511V21.1667H17.7134V14.2477C17.7134 12.5096 17.0933 11.3234 15.5417 11.3234C14.3572 11.3234 13.6524 12.1228 13.3423 12.8961C13.2292 13.1726 13.2001 13.5574 13.2001 13.9443V21.1667H8.91198C8.91198 21.1667 8.96973 9.44824 8.91198 8.23413H13.1996V10.0673C13.191 10.081 13.1797 10.0958 13.1715 10.109H13.1996V10.0673C13.7693 9.18733 14.7867 7.93031 17.0638 7.93031C19.885 7.93026 22 9.77869 22 13.7511ZM4.42646 2C2.95951 2 2 2.965 2 4.234C2 5.47535 2.93175 6.46964 4.36954 6.46964H4.39818C5.89355 6.46964 6.82352 5.47554 6.82352 4.234C6.79535 2.965 5.89355 2 4.42646 2ZM2.25467 21.1667H6.54114V8.23413H2.25467V21.1667Z"
  })));
}

export default SvgLinkedinIn;